import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

const EMPTY_SUBSCRIPTION = {
  success: true,
  data: {
    plan: null,
    availablePlans: [],
    status: null,
    users: { used: 0, limit: 0, remaining: 0, display: "0/0" },
    applicationImages: {
      approved: { used: 0, limit: 0, remaining: 0, display: "0/0" },
    },
  },
};

export const useViewSubscription = () => {
  return useQuery({
    queryKey: ["viewSubscription"],
    queryFn: async () => {
      try {
        const res = await api.get("/subscription/current");
        return res.data;
      } catch (error) {
        if (error?.response?.status === 404) return EMPTY_SUBSCRIPTION;
        throw error;
      }
    },
    retry: 1,
    retryDelay: 800,
    staleTime: 30_000,
    placeholderData: EMPTY_SUBSCRIPTION,
  });
};
